import React from "react";
import InputQuestion from "./InputQuestion";

function CurrencyQuestion(props) {
  return (
    <InputQuestion
      id={props.id}
      name={props.id}
      QuestionText={props.QuestionText}
      GuidelineText={props.GuidelineText}
      handleValue={props.handleValue}
      Symbol="$"
      Post=".00"
      Unit="Dollars"
      Answer={props.Answer}
    />
  );
}

export default CurrencyQuestion;
